import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import _regeneratorRuntime from "@babel/runtime/regenerator";
import B from "../platform/index.js";
import r from "../utils.js";
import l from "../core/AxiosError.js";
import H from "../helpers/composeSignals.js";
import { trackStream as L } from "../helpers/trackStream.js";
import K from "../core/AxiosHeaders.js";
import { progressEventDecorator as P, progressEventReducer as A, asyncDecorator as O } from "../helpers/progressEventReducer.js";
import z from "../helpers/resolveConfig.js";
import j from "../core/settle.js";
var w = typeof fetch == "function" && typeof Request == "function" && typeof Response == "function",
  D = w && typeof ReadableStream == "function",
  I = w && (typeof TextEncoder == "function" ? /* @__PURE__ */function (e) {
    return function (t) {
      return e.encode(t);
    };
  }(new TextEncoder()) : (/*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(e) {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.t0 = Uint8Array;
            _context.next = 3;
            return new Response(e).arrayBuffer();
          case 3:
            _context.t1 = _context.sent;
            return _context.abrupt("return", new _context.t0(_context.t1));
          case 5:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }())),
  F = function F(e) {
    try {
      for (var _len = arguments.length, t = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        t[_key - 1] = arguments[_key];
      }
      return !!e.apply(void 0, t);
    } catch (_unused) {
      return !1;
    }
  },
  J = D && F(function () {
    var e = !1;
    var t = new Request(B.origin, {
      body: new ReadableStream(),
      method: "POST",
      get duplex() {
        return e = !0, "half";
      }
    }).headers.has("Content-Type");
    return e && !t;
  }),
  _ = 64 * 1024,
  T = D && F(function () {
    return r.isReadableStream(new Response("").body);
  }),
  g = {
    stream: T && function (e) {
      return e.body;
    }
  };
w && function (e) {
  ["text", "arrayBuffer", "blob", "formData", "stream"].forEach(function (t) {
    !g[t] && (g[t] = r.isFunction(e[t]) ? function (s) {
      return s[t]();
    } : function (s, u) {
      throw new l("Response type '".concat(t, "' is not supported"), l.ERR_NOT_SUPPORT, u);
    });
  });
}(new Response());
var V = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2(e) {
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            if (!(e == null)) {
              _context2.next = 2;
              break;
            }
            return _context2.abrupt("return", 0);
          case 2:
            if (!r.isBlob(e)) {
              _context2.next = 4;
              break;
            }
            return _context2.abrupt("return", e.size);
          case 4:
            if (!r.isSpecCompliantForm(e)) {
              _context2.next = 8;
              break;
            }
            _context2.next = 7;
            return new Request(B.origin, {
              method: "POST",
              body: e
            }).arrayBuffer();
          case 7:
            return _context2.abrupt("return", _context2.sent.byteLength);
          case 8:
            if (!(r.isArrayBufferView(e) || r.isArrayBuffer(e))) {
              _context2.next = 10;
              break;
            }
            return _context2.abrupt("return", e.byteLength);
          case 10:
            if (!(r.isURLSearchParams(e) && (e = e + ""), r.isString(e))) {
              _context2.next = 14;
              break;
            }
            _context2.next = 13;
            return I(e);
          case 13:
            return _context2.abrupt("return", _context2.sent.byteLength);
          case 14:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return function V(_x2) {
      return _ref2.apply(this, arguments);
    };
  }(),
  W = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee3(e, t) {
      var s;
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            s = r.toFiniteNumber(e.getContentLength());
            return _context3.abrupt("return", s !== null && s !== void 0 ? s : V(t));
          case 2:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    }));
    return function W(_x3, _x4) {
      return _ref3.apply(this, arguments);
    };
  }(),
  re = w && (/*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee4(e) {
      var _z, t, s, u, N, x, U, R, b, n, y, _z$withCredentials, m, v, d, f, c, E, i, p, _P, _P2, S, h, o, a, C, _i, _p, _ref5, _ref6, _S, _h, k;
      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            _z = z(e), t = _z.url, s = _z.method, u = _z.data, N = _z.signal, x = _z.cancelToken, U = _z.timeout, R = _z.onDownloadProgress, b = _z.onUploadProgress, n = _z.responseType, y = _z.headers, _z$withCredentials = _z.withCredentials, m = _z$withCredentials === void 0 ? "same-origin" : _z$withCredentials, v = _z.fetchOptions;
            n = n ? (n + "").toLowerCase() : "text";
            d = H([N, x && x.toAbortSignal()], U);
            c = d && d.unsubscribe && function () {
              d.unsubscribe();
            };
            _context4.prev = 4;
            _context4.t0 = b && J && s !== "get" && s !== "head";
            if (!_context4.t0) {
              _context4.next = 11;
              break;
            }
            _context4.next = 9;
            return W(y, u);
          case 9:
            _context4.t1 = E = _context4.sent;
            _context4.t0 = _context4.t1 !== 0;
          case 11:
            if (!_context4.t0) {
              _context4.next = 14;
              break;
            }
            i = new Request(t, {
              method: "POST",
              body: u,
              duplex: "half"
            });
            if (r.isFormData(u) && (p = i.headers.get("content-type")) && y.setContentType(p), i.body) {
              _P = P(E, A(O(b))), _P2 = _slicedToArray(_P, 2), S = _P2[0], h = _P2[1];
              u = L(i.body, _, S, h);
            }
          case 14:
            r.isString(m) || (m = m ? "include" : "omit");
            o = "credentials" in Request.prototype;
            f = new Request(t, _objectSpread(_objectSpread({}, v), {}, {
              signal: d,
              method: s.toUpperCase(),
              headers: y.normalize().toJSON(),
              body: u,
              duplex: "half",
              credentials: o ? m : void 0
            }));
            _context4.next = 19;
            return fetch(f);
          case 19:
            a = _context4.sent;
            C = T && (n === "stream" || n === "response");
            if (T && (R || C && c)) {
              _i = {};
              ["status", "statusText", "headers"].forEach(function (q) {
                _i[q] = a[q];
              });
              _p = r.toFiniteNumber(a.headers.get("content-length")), _ref5 = R && P(_p, A(O(R), !0)) || [], _ref6 = _slicedToArray(_ref5, 2), _S = _ref6[0], _h = _ref6[1];
              a = new Response(L(a.body, _, _S, function () {
                _h && _h(), c && c();
              }), _i);
            }
            n = n || "text";
            _context4.next = 25;
            return g[r.findKey(g, n) || "text"](a, e);
          case 25:
            k = _context4.sent;
            !C && c && c();
            _context4.next = 29;
            return new Promise(function (i, p) {
              j(i, p, {
                data: k,
                headers: K.from(a.headers),
                status: a.status,
                statusText: a.statusText,
                config: e,
                request: f
              });
            });
          case 29:
            return _context4.abrupt("return", _context4.sent);
          case 32:
            _context4.prev = 32;
            _context4.t2 = _context4["catch"](4);
            throw c && c(), _context4.t2 && _context4.t2.name === "TypeError" && /fetch/i.test(_context4.t2.message) ? Object.assign(new l("Network Error", l.ERR_NETWORK, e, f), {
              cause: _context4.t2.cause || _context4.t2
            }) : l.from(_context4.t2, _context4.t2 && _context4.t2.code, e, f);
          case 35:
          case "end":
            return _context4.stop();
        }
      }, _callee4, null, [[4, 32]]);
    }));
    return function (_x5) {
      return _ref4.apply(this, arguments);
    };
  }());
export { re as default };
